import * as compiler from './compiler';
import parser, { getTokens } from './parser';

export interface NewlineToken {
  type: 'newline';
}

export interface CharacterToken {
  type: 'character';
  data: string;
}

export interface VariableToken {
  type: 'variable';
  data: {
    variableName: string;
    defaultValue: string | null | undefined;
  };
}

export interface StringToken {
  type: 'string';
  data: string;
}

type Token = NewlineToken | CharacterToken | VariableToken;

interface Paragraph {
  new ();
  push(item: Token): void;
  getLastItem(): NewlineToken | CharacterToken | VariableToken | StringToken;
  getLastItemType(): string;
  mergeWithLastItem(item: Token): void;
  isEmpty(): boolean;
}

interface Template {
  paragraphs: Paragraph[];
}

interface ReactTemplateProps {
  template: Template;
  data: Record<string, unknown>;
}

type Tokenizer = (text: string) => Token[];
type Parser = (tokens: Token[]) => Template;
type CompileToString = (
  template: Template,
  data: Record<string, unknown>
) => string;
type ReactTemplateComponent = (props: ReactTemplateProps) => JSX.Element;

export const parse: Parser = parser;
export const tokenize: Tokenizer = getTokens;
export const toString: CompileToString = compiler.toString;
export const ReactTemplate: ReactTemplateComponent = compiler.ReactTemplate;
